export const PUBLIC_AUTH_ROUTE_PREFIXES = [
  '/auth/confirm-user-self-registration',
  '/invite/',
  '/logout',
  '/confirm-login',
];

export function isPublicAuthRoute(
  ...urls: (string | null | undefined)[]
): boolean {
  return urls.some(
    (url) =>
      !!url &&
      PUBLIC_AUTH_ROUTE_PREFIXES.some((prefix) => url.startsWith(prefix)),
  );
}
